module.exports = __webpack_public_path__ + "assets/img/icon_record_audio.e87c89ee.png";